require("channels");
import "@stimulus/polyfills"
import {Application} from "stimulus"
import {definitionsFromContext} from "stimulus/webpack-helpers"

const application = Application.start()
const context = require.context("concierge", true, /-controller\.js$/)
application.load(definitionsFromContext(context))

const Rails = require('@rails/ujs');
Rails.start();
